import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const create = payload => api.post('/platform/api/v1/account', payload)

const getTestCompany = payload => api.get(`/platform/account/test-company`, payload)

const getPermissions = payload => api.get('/platform/privilege', payload)

const getUserData = payload => api.get(`/platform/account/data/${payload.userId}`, payload)

const resetPassword = payload =>
  api.post('/platform/resetPassword', payload.data, { params: payload.params })

const getUserAccounts = payload => api.get('/platform/account/manage', payload)

const getUserRoles = payload => api.get('/platform/account/select/role', payload)

const getCustodians = payload => api.get('/platform/account/select/custodian', payload)

const createAccount = payload =>
  api.post(`/platform/account`, payload.data, { params: payload.params })

const editAccount = payload =>
  api.put(`/platform/account/manage`, payload.data, {
    params: payload.params,
  })

const deleteAccount = payload =>
  api.delete(`/platform/account/manage/${payload.userId}`, { params: payload.params })

const getPlanDetails = payload => api.get(`/platform/plan/${payload.planId}`, payload)

export default {
  create,
  getTestCompany,
  getPermissions,
  getUserData,
  resetPassword,
  getUserAccounts,
  getUserRoles,
  getCustodians,
  createAccount,
  editAccount,
  deleteAccount,
  getPlanDetails,
}
